import { cookie } from '@/helpers';
import { ApiPlugin } from '@/plugins';

export default class UserSession {
  static async getAPIToken() {
    try {
      const response = await ApiPlugin.get(
        '/session/token?_format=json',
      );
      cookie.setCookie('token', response.data.trim());
      return true;
    } catch (e) {
      console.error('Error fetching fresh token \n', e);
      return false;
    }
  }
}
